// @ts-nocheck
import React from 'react';
import { ApplyPluginsType, dynamic } from '/root/bfe-epc-web/node_modules/umi/node_modules/@umijs/runtime';
import * as umiExports from './umiExports';
import { plugin } from './plugin';
import LoadingComponent from '@/components/Loading';

export function getRoutes() {
  const routes = [
  {
    "path": "/static/",
    "name": "",
    "component": dynamic({ loader: () => import(/* webpackChunkName: 'layouts__static-layout__index' */'@/layouts/static-layout/index'), loading: LoadingComponent}),
    "hideInMenu": true,
    "routes": [
      {
        "path": "/static/forget",
        "name": "忘记密码",
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__static__forget-pwd' */'/root/bfe-epc-web/src/pages/static/forget-pwd'), loading: LoadingComponent}),
        "exact": true
      },
      {
        "path": "/static/privacy",
        "name": "隐私政策",
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__static__privacy' */'/root/bfe-epc-web/src/pages/static/privacy'), loading: LoadingComponent}),
        "exact": true
      },
      {
        "path": "/static/cascade-privacy",
        "name": "用户协议",
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__static__cascade-privacy' */'/root/bfe-epc-web/src/pages/static/cascade-privacy'), loading: LoadingComponent}),
        "exact": true
      },
      {
        "path": "/static/protocol",
        "name": "网络货运服务协议",
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__static__protocol' */'/root/bfe-epc-web/src/pages/static/protocol'), loading: LoadingComponent}),
        "exact": true
      },
      {
        "path": "/static/icons",
        "name": "权限",
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__static__icons-show' */'/root/bfe-epc-web/src/pages/static/icons-show'), loading: LoadingComponent}),
        "exact": true
      }
    ]
  },
  {
    "path": "/mobile-view",
    "name": "",
    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__mobile-view' */'/root/bfe-epc-web/src/pages/mobile-view'), loading: LoadingComponent}),
    "hideInMenu": true,
    "exact": true
  },
  {
    "path": "/",
    "component": dynamic({ loader: () => import(/* webpackChunkName: 'layouts__index' */'@/layouts/index'), loading: LoadingComponent}),
    "wrappers": [dynamic({ loader: () => import(/* webpackChunkName: 'wrappers' */'@/routes/wrappers'), loading: LoadingComponent})],
    "routes": [
      {
        "path": "/home",
        "name": "首页",
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__home' */'/root/bfe-epc-web/src/pages/home'), loading: LoadingComponent}),
        "access": "canShowHome",
        "exact": true
      },
      {
        "path": "/data-center",
        "name": "数据中心",
        "access": "canShowDataCenter",
        "routes": [
          {
            "path": "/data-center/data-big-screen",
            "name": "数据大屏",
            "access": "canShowDataBigScreen",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__data-center-data-big-screen' */'/root/bfe-epc-web/src/pages/data-center-data-big-screen'), loading: LoadingComponent}),
            "exact": true
          }
        ]
      },
      {
        "path": "/order-center",
        "name": "订单中心",
        "access": "canShowOrderCenter",
        "routes": [
          {
            "path": "/order-center/same-city",
            "name": "货运在线下单",
            "access": "canShowOrderCenterSameCity",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__order-center-order-home' */'/root/bfe-epc-web/src/pages/order-center-order-home'), loading: LoadingComponent}),
            "exact": true
          },
          {
            "path": "/order-center/ccl-order-placed",
            "name": "冷链零担下单",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__ccl-order-placed' */'/root/bfe-epc-web/src/pages/ccl-order-placed'), loading: LoadingComponent}),
            "exact": true
          },
          {
            "path": "/order-center/ccl-order-detail",
            "name": "冷链零担订单详情",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__ccl-order-detail' */'/root/bfe-epc-web/src/pages/ccl-order-detail'), loading: LoadingComponent}),
            "hideInMenu": true,
            "exact": true
          },
          {
            "path": "/order-center/order-list",
            "name": "订单列表",
            "access": "canShowOrderCenterOrderListNew",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__order-list' */'/root/bfe-epc-web/src/pages/order-list'), loading: LoadingComponent}),
            "exact": true
          },
          {
            "path": "/order-center/order-approval",
            "name": "订单审批",
            "access": "canShowOrderCenterOrderApproval",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__order-center-order-approval' */'/root/bfe-epc-web/src/pages/order-center-order-approval'), loading: LoadingComponent}),
            "exact": true
          },
          {
            "path": "/order-center/freight-order-detail",
            "name": "定制城配订单详情",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__order-list__freight-order-detail' */'/root/bfe-epc-web/src/pages/order-list/freight-order-detail'), loading: LoadingComponent}),
            "hideInMenu": true,
            "exact": true
          },
          {
            "path": "/order-center/same-city-order-confirm",
            "name": "确认订单",
            "access": "canShowOrderCenterSameCity",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__order-center-order-confirm' */'/root/bfe-epc-web/src/pages/order-center-order-confirm'), loading: LoadingComponent}),
            "hideInMenu": true,
            "exact": true
          },
          {
            "path": "/order-center/same-city-order-detail",
            "name": "订单详情",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__order-center-order-detail' */'/root/bfe-epc-web/src/pages/order-center-order-detail'), loading: LoadingComponent}),
            "hideInMenu": true,
            "exact": true
          },
          {
            "path": "/order-center/insurance",
            "name": "保险详情",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__order-center-insurance' */'/root/bfe-epc-web/src/pages/order-center-insurance'), loading: LoadingComponent}),
            "hideInMenu": true,
            "exact": true
          },
          {
            "path": "/order-center/order-charge",
            "name": "收费标准说明",
            "access": "canShowOrderCenterOrderChargeNew",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__order-center-order-charge' */'/root/bfe-epc-web/src/pages/order-center-order-charge'), loading: LoadingComponent}),
            "exact": true
          },
          {
            "path": "/order-center/order-approval-detail",
            "name": "审批详情",
            "asscess": "canShowOrderCenterOrderApproval",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__order-center-order-approval-detail' */'/root/bfe-epc-web/src/pages/order-center-order-approval-detail'), loading: LoadingComponent}),
            "hideInMenu": true,
            "exact": true
          },
          {
            "path": "/order-center/receiving-note-detail",
            "name": "收货单详情",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__order-center-order-detail__receiving-note-detail' */'/root/bfe-epc-web/src/pages/order-center-order-detail/receiving-note-detail'), loading: LoadingComponent}),
            "hideInMenu": true,
            "exact": true
          }
        ]
      },
      {
        "path": "/order-config",
        "name": "订单配置",
        "acess": "canShowOrderCenter",
        "routes": [
          {
            "path": "/order-config/collect-driver-list",
            "name": "收藏司机管理",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__collect-driver-list' */'/root/bfe-epc-web/src/pages/collect-driver-list'), loading: LoadingComponent}),
            "access": "canShowOrderConfigFavorityDriverNew",
            "exact": true
          },
          {
            "path": "/order-config/use-car-reason-setting",
            "name": "用车原由设置",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__order-config-use-car-reason-setting' */'/root/bfe-epc-web/src/pages/order-config-use-car-reason-setting'), loading: LoadingComponent}),
            "access": "canShowOrderConfigUserCarReasonSetting",
            "exact": true
          },
          {
            "path": "/order-config/address-manage",
            "name": "地址簿管理",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__address-manage' */'/root/bfe-epc-web/src/pages/address-manage'), loading: LoadingComponent}),
            "exact": true
          },
          {
            "path": "/order-config/address-manage/batch-upload",
            "name": "批量导入地址簿",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__address-manage__batch-upload' */'/root/bfe-epc-web/src/pages/address-manage/batch-upload'), loading: LoadingComponent}),
            "hideInMenu": true,
            "exact": true
          }
        ]
      },
      {
        "path": "/company-manage",
        "name": "企业管理",
        "access": "canShowCompanyManage",
        "routes": [
          {
            "path": "/company-manage/company-verify",
            "name": "企业认证",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__company-manage-company-verify' */'/root/bfe-epc-web/src/pages/company-manage-company-verify'), loading: LoadingComponent}),
            "access": "canShowCompanyManageCompanyVerify",
            "exact": true
          },
          {
            "path": "/company-manage/super-manager-transfer",
            "name": "超级管理员转让",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__company-manage-super-manager-transfer' */'/root/bfe-epc-web/src/pages/company-manage-super-manager-transfer'), loading: LoadingComponent}),
            "access": "canShowCompanyManageSuperManagerTransfer",
            "exact": true
          },
          {
            "path": "/company-manage/super-manager-transfer/confirm",
            "name": "超管转让确认",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__company-manage-super-manager-transfer__confirm' */'/root/bfe-epc-web/src/pages/company-manage-super-manager-transfer/confirm'), loading: LoadingComponent}),
            "hideInMenu": true,
            "exact": true
          },
          {
            "path": "/company-manage/rights-management",
            "name": "权限管理",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__rights-management' */'/root/bfe-epc-web/src/pages/rights-management'), loading: LoadingComponent}),
            "access": "canShowRightsManage",
            "exact": true
          },
          {
            "path": "/company-manage/unregister-apply",
            "name": "注销企业",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__company-manage-company-unregister__unregister-apply' */'/root/bfe-epc-web/src/pages/company-manage-company-unregister/unregister-apply'), loading: LoadingComponent}),
            "access": "canShowCompanyMagageCompanyUnregister",
            "exact": true
          },
          {
            "path": "/company-manage/logoutApply",
            "name": "企业注销原因",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__company-manage-company-unregister__unregister-apply' */'/root/bfe-epc-web/src/pages/company-manage-company-unregister/unregister-apply'), loading: LoadingComponent}),
            "hideInMenu": true,
            "exact": true
          },
          {
            "path": "/company-manage/logoutValidate",
            "name": "企业注销验证",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__company-manage-company-unregister__logout-validate' */'/root/bfe-epc-web/src/pages/company-manage-company-unregister/logout-validate'), loading: LoadingComponent}),
            "hideInMenu": true,
            "exact": true
          },
          {
            "path": "/company-manage/rights-management/add",
            "name": "新增权限",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__rights-management__edit' */'/root/bfe-epc-web/src/pages/rights-management/edit'), loading: LoadingComponent}),
            "hideInMenu": true,
            "exact": true
          },
          {
            "path": "/company-manage/rights-management/edit",
            "name": "编辑权限",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__rights-management__edit' */'/root/bfe-epc-web/src/pages/rights-management/edit'), loading: LoadingComponent}),
            "hideInMenu": true,
            "exact": true
          }
        ]
      },
      {
        "path": "/organization",
        "name": "组织架构",
        "access": "canShowStaffOrganization",
        "routes": [
          {
            "path": "/organization/company-associate",
            "name": "企业关联",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__organization-company-associate' */'/root/bfe-epc-web/src/pages/organization-company-associate'), loading: LoadingComponent}),
            "access": "canShowStaffOrganizationCompanyAssociateNew",
            "exact": true
          },
          {
            "path": "/organization/company-associate/associate-sub-enterprise",
            "name": "关联子企业",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__organization-company-associate__associate-sub-enterprise' */'/root/bfe-epc-web/src/pages/organization-company-associate/associate-sub-enterprise'), loading: LoadingComponent}),
            "hideInMenu": true,
            "exact": true
          },
          {
            "path": "/organization/company-associate/batch-upload",
            "name": "批量上传",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__organization-company-associate__batch-upload' */'/root/bfe-epc-web/src/pages/organization-company-associate/batch-upload'), loading: LoadingComponent}),
            "hideInMenu": true,
            "exact": true
          },
          {
            "path": "/organization/company-associate/sub-ep-detail",
            "name": "子企业详情",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__organization-company-associate__sub-ep-detail' */'/root/bfe-epc-web/src/pages/organization-company-associate/sub-ep-detail'), loading: LoadingComponent}),
            "hideInMenu": true,
            "exact": true
          },
          {
            "path": "/organization/company-associate/edit-group",
            "name": "编辑分组",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__organization-company-associate__edit-group' */'/root/bfe-epc-web/src/pages/organization-company-associate/edit-group'), loading: LoadingComponent}),
            "hideInMenu": true,
            "exact": true
          },
          {
            "path": "/organization/staff-manage",
            "name": "员工管理",
            "access": "canShowStaffOrganizationStaffManage",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__organization-manage-staff' */'/root/bfe-epc-web/src/pages/organization-manage-staff'), loading: LoadingComponent}),
            "exact": true
          },
          {
            "path": "/organization/staff-manage/edit",
            "name": "编辑员工",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__organization-manage-staff__edit' */'/root/bfe-epc-web/src/pages/organization-manage-staff/edit'), loading: LoadingComponent}),
            "hideInMenu": true,
            "exact": true
          },
          {
            "path": "/organization/staff-manage/add",
            "name": "新增员工",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__organization-manage-staff__edit' */'/root/bfe-epc-web/src/pages/organization-manage-staff/edit'), loading: LoadingComponent}),
            "hideInMenu": true,
            "exact": true
          },
          {
            "path": "/organization/staff-manage/batch-edit",
            "name": "批量设置员工",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__organization-manage-staff__batch-edit' */'/root/bfe-epc-web/src/pages/organization-manage-staff/batch-edit'), loading: LoadingComponent}),
            "hideInMenu": true,
            "exact": true
          },
          {
            "path": "/organization/staff-batch-upload",
            "name": "批量导入",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__organization-manage-staff__batch-upload' */'/root/bfe-epc-web/src/pages/organization-manage-staff/batch-upload'), loading: LoadingComponent}),
            "hideInMenu": true,
            "exact": true
          },
          {
            "path": "/organization/department-manage",
            "name": "部门管理",
            "access": "canShowStaffOrganizationDepartmentManage",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__organization-mange-departmant' */'/root/bfe-epc-web/src/pages/organization-mange-departmant'), loading: LoadingComponent}),
            "exact": true
          },
          {
            "path": "/organization/department-manage/batch-edit",
            "name": "批量设置部门",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__organization-mange-departmant__batch-edit' */'/root/bfe-epc-web/src/pages/organization-mange-departmant/batch-edit'), loading: LoadingComponent}),
            "hideInMenu": true,
            "exact": true
          },
          {
            "path": "/organization/department-batch-upload",
            "name": "批量导入",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__organization-mange-departmant__batch-upload' */'/root/bfe-epc-web/src/pages/organization-mange-departmant/batch-upload'), loading: LoadingComponent}),
            "hideInMenu": true,
            "exact": true
          }
        ]
      },
      {
        "path": "/finance-manage",
        "name": "财务管理",
        "access": "canShowFinanceManage",
        "routes": [
          {
            "path": "/finance-manage/wallet",
            "name": "钱包充值",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__finance-manage-wallet' */'/root/bfe-epc-web/src/pages/finance-manage-wallet'), loading: LoadingComponent}),
            "access": "canShowFinanceManageRechargeOnlineNew",
            "exact": true
          },
          {
            "path": "/finance-manage/monthly-manage",
            "name": "月结管理",
            "access": "canShowMonthlyManage",
            "routes": [
              {
                "path": "/finance-manage/monthly-manage/monthly-bill",
                "name": "月结账单",
                "access": "canShowMonthBill",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__monthly-manage__monthly-bill' */'/root/bfe-epc-web/src/pages/monthly-manage/monthly-bill'), loading: LoadingComponent}),
                "exact": true
              },
              {
                "path": "/finance-manage/monthly-manage/share-bill",
                "name": "共享月结账单",
                "access": "canShowShareBill",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__monthly-manage__share-bill' */'/root/bfe-epc-web/src/pages/monthly-manage/share-bill'), loading: LoadingComponent}),
                "exact": true
              },
              {
                "path": "/finance-manage/monthly-manage/account-info",
                "name": "账户信息",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__monthly-manage__account-info' */'/root/bfe-epc-web/src/pages/monthly-manage/account-info'), loading: LoadingComponent}),
                "exact": true
              },
              {
                "path": "/finance-manage/monthly-manage/repayment-flow",
                "name": "还款记录",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__monthly-manage__repayment-flow' */'/root/bfe-epc-web/src/pages/monthly-manage/repayment-flow'), loading: LoadingComponent}),
                "exact": true
              },
              {
                "path": "/finance-manage/monthly-manage/account-apply",
                "name": "账期申请",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__monthly-manage__account-apply' */'/root/bfe-epc-web/src/pages/monthly-manage/account-apply'), loading: LoadingComponent}),
                "hideInMenu": true,
                "exact": true
              }
            ]
          },
          {
            "path": "/finance-manage/wallet-flow",
            "name": "钱包余额流水",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__finance-manage-flow' */'/root/bfe-epc-web/src/pages/finance-manage-flow'), loading: LoadingComponent}),
            "access": "canShowFinanceManageFinancialFlowNew",
            "exact": true
          },
          {
            "path": "/finance-manage/invoice-manage",
            "name": "发票管理",
            "access": "canShowFinanceManageInvoiceApplyNew",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__invoice-manage' */'/root/bfe-epc-web/src/pages/invoice-manage'), loading: LoadingComponent}),
            "exact": true
          },
          {
            "path": "/finance-manage/coupon",
            "name": "优惠券管理",
            "access": "canShowFinanceManageCoupon",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__finance-manage-coupon-manange' */'/root/bfe-epc-web/src/pages/finance-manage-coupon-manange'), loading: LoadingComponent}),
            "exact": true
          },
          {
            "path": "/finance-manage/check-tool",
            "name": "对账工具",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__check-tool' */'/root/bfe-epc-web/src/pages/check-tool'), loading: LoadingComponent}),
            "access": "canShowCheckTool",
            "exact": true
          },
          {
            "path": "/finance-manage/balance-warning",
            "name": "余额预警",
            "access": "canShowBalanceWarning",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__finance-manage-balance-warning' */'/root/bfe-epc-web/src/pages/finance-manage-balance-warning'), loading: LoadingComponent}),
            "exact": true
          },
          {
            "path": "/finance-manage/finance-payment-agree",
            "name": "授权委托书",
            "access": "canShowPaymentAgree",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__finance-payment-agree' */'/root/bfe-epc-web/src/pages/finance-payment-agree'), loading: LoadingComponent}),
            "exact": true
          },
          {
            "path": "/finance-manage/payway-setting",
            "name": "支付设置",
            "access": "canShowPaywaySetting",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__finance-manage-payway-setting' */'/root/bfe-epc-web/src/pages/finance-manage-payway-setting'), loading: LoadingComponent}),
            "exact": true
          }
        ]
      },
      {
        "path": "/activity-intro",
        "name": "活动介绍页",
        "hideInMenu": true,
        "routes": [
          {
            "path": "/activity-intro/ep-pc-intro",
            "name": "企业PC介绍",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__activity-intro__ep-pc-intro' */'/root/bfe-epc-web/src/pages/activity-intro/ep-pc-intro'), loading: LoadingComponent}),
            "exact": true
          },
          {
            "path": "/activity-intro/step-pricing",
            "name": "活动",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__activity-intro__step-pricing' */'/root/bfe-epc-web/src/pages/activity-intro/step-pricing'), loading: LoadingComponent}),
            "exact": true
          },
          {
            "path": "/activity-intro/score-landing-page",
            "name": "积分活动页",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__activity-intro__score-landing-page' */'/root/bfe-epc-web/src/pages/activity-intro/score-landing-page'), loading: LoadingComponent}),
            "exact": true
          }
        ]
      },
      {
        "path": "/personal-center",
        "name": "个人中心",
        "hideInMenu": true,
        "routes": [
          {
            "path": "/personal-center/info",
            "name": "个人中心",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__personal-center__info' */'/root/bfe-epc-web/src/pages/personal-center/info'), loading: LoadingComponent}),
            "exact": true
          },
          {
            "path": "/personal-center/password",
            "name": "修改密码",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__personal-center__password' */'/root/bfe-epc-web/src/pages/personal-center/password'), loading: LoadingComponent}),
            "exact": true
          },
          {
            "path": "/personal-center/customer-service",
            "name": "客服中心",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__personal-center__customer-service' */'/root/bfe-epc-web/src/pages/personal-center/customer-service'), loading: LoadingComponent}),
            "exact": true
          }
        ]
      },
      {
        "path": "/message-box",
        "name": "消息中心",
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__message-box' */'/root/bfe-epc-web/src/pages/message-box'), loading: LoadingComponent}),
        "hideInMenu": true,
        "exact": true
      },
      {
        "path": "/activity-task",
        "name": "阶梯讲价任务",
        "hideInMenu": true,
        "routes": [
          {
            "path": "/activity-task/activity-task",
            "name": "企业PC介绍",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__activity-intro__ep-pc-intro' */'/root/bfe-epc-web/src/pages/activity-intro/ep-pc-intro'), loading: LoadingComponent}),
            "exact": true
          }
        ]
      },
      {
        "path": "/*",
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__404' */'/root/bfe-epc-web/src/pages/404'), loading: LoadingComponent}),
        "menuRender": false,
        "exact": true
      }
    ]
  }
];

  // allow user to extend routes
  plugin.applyPlugins({
    key: 'patchRoutes',
    type: ApplyPluginsType.event,
    args: { routes },
  });

  return routes;
}
